/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sortinghide1Inputs */

const en__field_sortinghide1 = /** @type {(inputs: _Field_Sortinghide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse sorting`)
};

const de__field_sortinghide1 = /** @type {(inputs: _Field_Sortinghide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortierung einklappen`)
};

/**
* | output |
* | --- |
* | "Collapse sorting" |
*
* @param {_Field_Sortinghide1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sortinghide1 = /** @type {((inputs?: _Field_Sortinghide1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sortinghide1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sortinghide1(inputs)
	return de__field_sortinghide1(inputs)
});
export { _field_sortinghide1 as "_field_sortingHide" }